import { ApolloClient } from '@apollo/client'

import organisationLogoCredentials from './operations/organisationLogoCredentials'
import getAWSSignatureV4Form from '../../utils/getAWSSignatureV4Form'
import axios from 'axios'

export const uploadLogoToS3 = async (
  client: ApolloClient<any>,
  file: File
): Promise<string> => {
  const credentials = await organisationLogoCredentials(client, file.name)
  const { params } = credentials

  const options = {
    headers: {
      'Content-Type': file.type
    },
    withCredentials: false
  }

  const fd = getAWSSignatureV4Form(params, file)

  await axios.post(credentials.uploadUrl, fd, options)
  const { key } = params

  if (credentials.publicCdnDomain) {
    // there is a cloudfront CDN for this env
    return `https://${credentials.publicCdnDomain}/${key}`
  } else {
    // envs without CLOUDFRONT_PUBLIC are running straight from S3
    return credentials.uploadUrl + key
  }
}
